import { Component, effect, inject, signal } from '@angular/core';
import { VisitAddFacade } from '@beautyapp/shared';
import { NotificationService } from '@beautyapp/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { InputModule } from '@beautyapp/form';
import { NzModalFooterDirective, NzModalRef } from 'ng-zorro-antd/modal';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzButtonComponent } from 'ng-zorro-antd/button';

@UntilDestroy()
@Component({
  selector: 'beautyapp-recipe-send-mail',
  imports: [
    ReactiveFormsModule,
    InputModule,
    TranslatePipe,
    NzModalFooterDirective,
    NzCheckboxModule,
    NzButtonComponent
  ],
  templateUrl: './recipe-send-mail.component.html',
  styleUrl: './recipe-send-mail.component.scss'
})
export class RecipeSendMailComponent {
  visitAddFacade = inject(VisitAddFacade);
  notificationService = inject(NotificationService);
  translateService = inject(TranslateService);
  modalRef = inject(NzModalRef);

  email = signal<string>('');
  loading = signal(false);

  form = new FormGroup({
    email: new FormControl<string>(this.email(), {
      validators: [
        Validators.email
      ],
      nonNullable: false
    }),
    sendToMobile: new FormControl<boolean>(true)
  });

  constructor() {
    effect(() => {
      if (this.email()) {
        this.form.patchValue({ email: this.email() }, { emitEvent: false });
      }
    });
  }

  sendRecipe() {
    this.form.markAllAsTouched();
    if (this.form.invalid) return;
    this.loading.set(true);
    const { email, sendToMobile } = this.form.value;

    this.visitAddFacade.sendRecipe({
      visitId: this.visitAddFacade.visitId, email, sendToMobile
    })
      .pipe(
        untilDestroyed(this)
      )
      .subscribe({
        next: (res) => {
          this.loading.set(false);
          this.modalRef.close();
          this.notificationService.success(
            this.translateService.instant('addVisit.sendRecipe.success'),
            this.translateService.instant('addVisit.sendRecipe.successMessage')
          );
        },
        error: (error) => {
          this.loading.set(false);
          this.notificationService.error(
            this.translateService.instant('addVisit.sendRecipe.error'),
            this.translateService.instant('addVisit.sendRecipe.errorMessage')
          );
        }
      });
  }
}
